export enum AccountFeatureFlags {
  reserveWithGoogle = 'reserveWithGoogle',
  savedReplies = 'savedReplies',
  togo = 'togo',
  whatsApp = 'whatsApp',
  floorPlan = 'floorPlan',
  squareCustomer = 'squareCustomer',
  paymentAccepting = 'paymentAccepting',
}

export const ACCOUNT_FEATURE_FLAG_TITLES: Record<AccountFeatureFlags, string> = {
  [AccountFeatureFlags.reserveWithGoogle]: 'Reserve with google',
  [AccountFeatureFlags.savedReplies]: 'Saved replies',
  [AccountFeatureFlags.togo]: 'To go',
  [AccountFeatureFlags.whatsApp]: 'Whatsapp',
  [AccountFeatureFlags.floorPlan]: 'Floor plan',
  [AccountFeatureFlags.squareCustomer]: 'Square sync customers',
  [AccountFeatureFlags.paymentAccepting]: 'Accept payments via stripe',
};
